import { render, staticRenderFns } from "./customer-group-list.vue?vue&type=template&id=6ab47f89&scoped=true"
import script from "./customer-group-list.vue?vue&type=script&lang=js"
export * from "./customer-group-list.vue?vue&type=script&lang=js"
import style0 from "./customer-group-list.vue?vue&type=style&index=0&id=6ab47f89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab47f89",
  null
  
)

export default component.exports